<template>
  <component
    :is="footerLogoComponent"
    data-test-id="footer-logo"
    class="bottom-footer__logo-img h-auto w-2/3 max-w-[183px] object-contain sm:max-w-[195px]"
  />
</template>
<script setup lang="ts">
import IconFooterAnniversaryLogoDe from 'assets/icons/footer/anniversary-logo/de.svg'
import IconFooterAnniversaryLogoNl from 'assets/icons/footer/anniversary-logo/nl.svg'
import IconFooterAnniversaryLogoFi from 'assets/icons/footer/anniversary-logo/fi.svg'
import IconFooterAnniversaryLogoFr from 'assets/icons/footer/anniversary-logo/fr.svg'
import IconFooterLogo from 'assets/icons/footer-logo.svg'
import useGlobalConfig from '~/composables/useGlobalConfig'

defineProps({
  isLanguageSwitch: {
    type: Boolean,
    default: false,
  },
})

const currentShop = useCurrentShop()
const { isGoldnerAnniversary } = useGlobalConfig()

const ANNIVERSARY_LOGO_BY_LOCALE: Record<string, any> = {
  de: IconFooterAnniversaryLogoDe,
  at: IconFooterAnniversaryLogoDe,
  ch: IconFooterAnniversaryLogoDe,

  be: IconFooterAnniversaryLogoNl,
  nl: IconFooterAnniversaryLogoNl,

  fi: IconFooterAnniversaryLogoFi,

  fr: IconFooterAnniversaryLogoFr,
  'fr-be': IconFooterAnniversaryLogoFr,
  'fr-ch': IconFooterAnniversaryLogoFr,
}

const footerLogoComponent = computed(() => {
  if (!isGoldnerAnniversary.value) {
    return IconFooterLogo
  }

  const locale = currentShop.value?.locale?.toLowerCase()

  return (
    (locale && ANNIVERSARY_LOGO_BY_LOCALE[locale]) ?? IconFooterLogo // safe fallback
  )
})
</script>

<style lang="postcss" scoped>
.bottom-footer__logo-img {
  @apply h-auto
  w-full;
}
</style>
